module.exports = __webpack_public_path__ + "media/standalone/laptop-14aed6df.svg";